module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-navigator', {
    attrs: {
      "swipeable": "",
      "swipe-target-width": "50px",
      "page-stack": _vm.pageStack,
      "pop-page": _vm.storePop,
      "options": _vm.options
    },
    on: {
      "postpush": _vm.showPopTip
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-191a7f40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 34
// module chunks = 0